import { NodeSocket, isBaseSocket } from "~/view-scene/script";

export const getFlowsNum = (sockets: NodeSocket[]) =>
  sockets.reduce((acc, out) => (isBaseSocket(out) && out.type === "flow" ? acc + 1 : acc), 0);
